(function () {
  function initVideTestimonials(section) {
    if (!section || section.dataset.videTestimonialsInitialized === 'true') return;
    section.dataset.videTestimonialsInitialized = 'true';

    var track = section.querySelector('.vide-testimonials__track');
    var slides = section.querySelectorAll('.vide-testimonials__card');
    var prevBtn = section.querySelector('.vide-testimonials__arrow--prev');
    var nextBtn = section.querySelector('.vide-testimonials__arrow--next');

    if (!track || slides.length === 0) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    // Read settings from data attributes
    var autoplayEnabled =
      section.dataset.autoplay === 'true' ||
      section.dataset.autoplay === '1';

    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '5000', 10);

    var slidesDesktop = parseInt(section.dataset.slidesDesktop || '4', 10);
    var slidesTablet = parseInt(section.dataset.slidesTablet || '2', 10);
    var slidesMobile = parseInt(section.dataset.slidesMobile || '1', 10);

    var currentIndex = 0;
    var slidesPerView = getSlidesPerView();
    var maxIndex = Math.max(0, slides.length - slidesPerView);

    var autoplayTimer = null;
    var slideStep = 0; // pixels to move per step

    function getSlidesPerView() {
      var width = window.innerWidth || document.documentElement.clientWidth;

      if (width <= 767) return slidesMobile;
      if (width <= 1024) return slidesTablet;
      return slidesDesktop;
    }

    function recalcMetrics() {
      slidesPerView = getSlidesPerView();
      maxIndex = Math.max(0, slides.length - slidesPerView);
      if (currentIndex > maxIndex) currentIndex = maxIndex;

      // Get gap between slides from computed style (supports gap/column-gap)
      var style = window.getComputedStyle(track);
      var gapValue = style.columnGap || style.gap || '0';
      var gap = parseFloat(gapValue) || 0;

      if (slides.length > 0) {
        slideStep = slides[0].offsetWidth + gap;
      } else {
        slideStep = 0;
      }

      updatePosition(false);
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;

      if (maxIndex === 0) {
        prevBtn.setAttribute('disabled', 'disabled');
        nextBtn.setAttribute('disabled', 'disabled');
        return;
      }

      if (currentIndex <= 0) {
        prevBtn.setAttribute('disabled', 'disabled');
      } else {
        prevBtn.removeAttribute('disabled');
      }

      if (currentIndex >= maxIndex) {
        nextBtn.setAttribute('disabled', 'disabled');
      } else {
        nextBtn.removeAttribute('disabled');
      }
    }

    function updatePosition(withTransition) {
      if (withTransition === void 0) withTransition = true;
      if (!track || slideStep === 0) return;

      var translateX = slideStep * currentIndex;

      if (!withTransition) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.4s ease';
      }

      track.style.transform = 'translateX(' + -translateX + 'px)';

      if (!withTransition) {
        // Force repaint so the next transitions animate correctly
        void track.offsetWidth;
        track.style.transition = 'transform 0.4s ease';
      }

      updateButtons();
    }

    function goToNext() {
      if (maxIndex === 0) return;
      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex += 1;
      }
      updatePosition(true);
    }

    function goToPrev() {
      if (maxIndex === 0) return;
      if (currentIndex <= 0) {
        currentIndex = maxIndex;
      } else {
        currentIndex -= 1;
      }
      updatePosition(true);
    }

    function startAutoplay() {
      if (!autoplayEnabled || maxIndex === 0) return;
      stopAutoplay();
      autoplayTimer = setInterval(goToNext, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        goToPrev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        goToNext();
        startAutoplay();
      });
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(recalcMetrics, 150);
    });

    // Initial setup
    recalcMetrics();
    startAutoplay();
  }

  function initAllVideTestimonials(root) {
    var context = root || document;
    var sections = context.querySelectorAll('.vide-testimonials');
    for (var i = 0; i < sections.length; i++) {
      initVideTestimonials(sections[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllVideTestimonials(document);
  });

  // For theme editor: re-init when section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    initAllVideTestimonials(event.target);
  });
})();